export default "__VITE_ASSET__14WUzotp__"